import { useEffect } from 'react';
var FONT_URLS = [
    {
        font: 'manrope',
        link: 'https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap'
    },
    {
        font: 'roboto',
        link: 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap'
    },
    {
        font: 'termina',
        link: 'https://fonts.proxima.ai/termina/termina.css'
    },
];
export default function useFonts() {
    useEffect(function () {
        var createLinkElement = function (_a) {
            var font = _a.font, link = _a.link;
            var id = "proxima-font-".concat(font, "-id");
            var element = document.getElementById(id);
            if (element)
                element.remove();
            var linkElement = document.createElement('link');
            linkElement.setAttribute('rel', 'stylesheet');
            linkElement.setAttribute('href', link);
            linkElement.setAttribute('id', id);
            document.head.appendChild(linkElement);
        };
        FONT_URLS.forEach(createLinkElement);
    }, []);
}
